/* eslint-disable no-sequences */
import axios from "axios";

import { apiToken, apiUrl_forCart } from "./constants";

import { apiUrl_forOrders } from "./constants";

const CancelToken = axios.CancelToken;

export let cancelGetOrdersApi;
export async function getOrders(token, query = "") {
    if (token) {
        const orders = await axios.get(apiUrl_forCart + "abandoneds?" + query, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrdersApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

// get order details
export let cancelGetOrderDetailsApi;
export async function getOrderDetails(token, orderId) {
    if (token && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders + `abandoneds/detail/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderDetailsApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// SET CUSTOM MESSAGE
export let cancelSendCustomMessageApi;
export async function sendCustomMessage(
    token,
    { temp_order_id, subject, message }
) {
    if (token && temp_order_id && subject && message) {
        const ordersData = await axios.post(
            apiUrl_forCart + `abandoneds/custom/emails`,
            {
                temp_order_id,
                subject,
                message,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSendCustomMessageApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}
